import { makeStyles } from '@material-ui/core';

import { useUser } from '@/hooks/useUser';

import { TableColumn } from '../../../../../config/types';

interface usePricingsTableProps {
  showInsurances?: boolean;
  minimalTable?: boolean;
}

export const usePricingsTable = ({ minimalTable = false, showInsurances }: usePricingsTableProps) => {
  const { userEntity } = useUser();

  const useStyles = makeStyles({
    root: {
      '& .MuiTableCell-root': {
        paddingInline: 6,
        paddingBlock: 8,
        '&:first-child': {
          paddingLeft: 0,
        },
      },
      '& .MuiTableRow-head': {
        verticalAlign: 'bottom',
      },
      '&. MuiButton-sizeSmall': {
        paddingInline: 2,
        minWidth: 10,
      },
    },
  });

  const classes = useStyles();

  const isAdminOrSuperAdmin = userEntity?.isRoleAdminOrSuperAdmin() ?? false;

  const columnsDesktop: TableColumn[] = [
    ...(isAdminOrSuperAdmin
      ? [{ name: 'pricingId', label: '', align: 'left' as const, sticky: true, colWidth: '5%' } as const]
      : []),
    { name: 'pricingName', label: 'NAME', align: 'left', colWidth: isAdminOrSuperAdmin ? '27%' : '20%' },
    { name: 'paymentMethodTypes', label: 'PAYMENT_METHOD_TYPE', align: 'left', colWidth: '16%' },
    ...(isAdminOrSuperAdmin ? [{ name: 'program', label: 'PROGRAM', align: 'left', colWidth: '16%' } as const] : []),
    { name: 'rangePrincipal', label: 'RANGE_PRINCIPAL', align: 'left', colWidth: isAdminOrSuperAdmin ? '18%' : '30%' },
    { name: 'rangePeriod', label: 'RANGE_PERIOD', align: 'left', colWidth: isAdminOrSuperAdmin ? '10%' : '20%' },
    ...(showInsurances
      ? [{ name: 'availableInsurances', label: 'AVAILABLE_INSURANCES', align: 'left', colWidth: '20%' } as const]
      : []),
    { name: 'lenders', label: 'LENDERS', align: 'left' },
    { name: 'more_actions', label: '', align: 'right' },
  ];

  const minimalColumnsDesktop: TableColumn[] = [
    { name: 'pricingName', label: 'PRICING_NAME', align: 'left', colWidth: '200px' },
    { name: 'paymentMethodTypes', label: 'PAYMENT_METHOD_TYPE', align: 'left', colWidth: '160px' },
    { name: 'program', label: 'PROGRAM', align: 'left', colWidth: '160px' },
    { name: 'rangePrincipal', label: 'RANGE_PRINCIPAL', align: 'left', colWidth: '220px' },
    { name: 'rangePeriod', label: 'RANGE_PERIOD', align: 'left', colWidth: '80px' },
  ];

  const columns = minimalTable ? minimalColumnsDesktop : columnsDesktop;

  return { classes, columns };
};
